
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import IUser from "@/models/protocols/IUser";
import Loader from "@/components/Loader.vue";
import UserService from "@/services/UserService";
import { Cart } from "@/types/Cart";

const { State } = namespace("Root");

@Component({
  components: {
    Loader,
  },
})
export default class UserInfo extends Vue {
  @State("user") user!: IUser;
  @State("cart") cart!: Cart;
  loading = false;

  async logOut() {
    this.loading = true;
    let result = await UserService.logOut();
    this.cart.quoteId = -1;
    this.cart.saved = false;
    // this.cart.persist();
    this.loading = false;
    // this.$router.push({ name: "wizard.two" });
  }
}
